var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2727_317",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 45,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0H48V45H3V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2727_317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4921 26.6838L3.68589 13.3233C3.60336 13.0905 3.72597 12.8327 3.95879 12.7476C6.50199 11.8341 9.15541 10.9405 11.8339 10.0396M37.324 36.1523L21.9693 41.6712L15.2307 44.094C14.9979 44.1792 14.7401 44.0565 14.655 43.8238L9.50337 29.4946",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3604 35.6314L24.415 38.3647L17.3559 39.5761C17.1131 39.6161 16.8779 39.4509 16.8352 39.2081L14.2295 24.003L11.3582 7.26351C11.3157 7.0183 11.4809 6.78548 11.7237 6.74294L19.769 5.36385",
    fill: "#EBF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3604 35.6314L24.415 38.3647L17.3559 39.5761C17.1131 39.6161 16.8779 39.4509 16.8352 39.2081L14.2295 24.003L11.3582 7.26351C11.3157 7.0183 11.4809 6.78548 11.7237 6.74294L19.769 5.36385",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7695 19.0666V1.34604C19.7695 1.08826 19.9799 0.878025 20.2376 0.878025H41.1669H41.5174C41.66 0.878025 41.7001 0.935593 41.9429 1.16587L47.077 6.06155C47.2847 6.26431 47.3423 6.28681 47.3423 6.42199V6.71229V27.5991V35.1603C47.3423 35.4181 47.1321 35.6309 46.8743 35.6309H27.7097H20.2376C19.9799 35.6309 19.7695 35.4181 19.7695 35.1603V22.1251",
    fill: "#EBF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7695 19.0666V1.34604C19.7695 1.08826 19.9799 0.878024 20.2376 0.878024H41.1669H41.5174C41.66 0.878024 41.7001 0.935592 41.9429 1.16587L47.077 6.06155C47.2847 6.26432 47.3423 6.28681 47.3423 6.42199V6.71229V27.5991V35.1603C47.3423 35.4181 47.1321 35.6309 46.8743 35.6309H27.7097H20.2376C19.9799 35.6309 19.7695 35.4181 19.7695 35.1603V22.1251",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.168 0.87881L41.178 5.52172C41.178 6.56041 42.1292 6.49529 42.5872 6.49529H47.3433",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1123 10.4551H24.2656",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1123 15.1387H24.2656",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1123 19.8203H24.2656",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1123 24.5039H24.2656",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1123 29.1875H24.2656",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07055 40.9294C0.643149 39.502 0.643149 37.1878 2.07055 35.7605L16.8139 21.0171L23.3641 19.6328L21.983 26.1861L7.2395 40.9294C5.81219 42.3568 3.49796 42.3568 2.07055 40.9294Z",
    fill: "url(#paint0_linear_2727_317)",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51172 33.3184L9.68067 38.4873",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2727_317",
    x1: 23,
    y1: 20,
    x2: 1.0029,
    y2: 41.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/Blog.6210ef49d7b23e72f968cf154fb35ad9.svg";
export { ForwardRef as ReactComponent };